import { http } from '../../config/axios'

const deleteUserPasskey = (id: number): Promise<void> => {
  return http
    .delete(`api/user/passkey/${id}`)
    .then(() => undefined)
    .catch((error) => {
      console.error('Erro deleteUserPasskey', error)
      throw Error(error.response?.data)
    })
}

export default deleteUserPasskey
